// extracted by mini-css-extract-plugin
export default {"account":"UserNameView-module--account--F-LyW"};